import { useEffect } from "react";

const BASE = "Rakesh Kadam | DevSecOps Lead & Cloud Engineer";

export function useDocumentTitle(page?: string) {
  useEffect(() => {
    document.title = page ? `${page} | Rakesh Kadam` : BASE;
    return () => { document.title = BASE; };
  }, [page]);
}
